import { useSyncExternalStore } from "react";
import { useSelfQuery } from "./queries/user-queries";

const FEATURE_TOGGLE_KEY = "amplifilesFeaturesEnabled";

const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return localStorage.getItem(FEATURE_TOGGLE_KEY) === "true";
}

function setFeatureToggle(enabled: boolean) {
  localStorage.setItem(FEATURE_TOGGLE_KEY, String(enabled));
  listeners.forEach((listener) => listener());
}

function useIsAmplifilesTeamMember() {
  const { data } = useSelfQuery();

  return data?.contactEmail.includes("@amplifiles.ai") ?? false;
}

// Used for Amplifiles team for now to enable admin mode.
export function useIsFeatureEnabled() {
  const isTeamMember = useIsAmplifilesTeamMember();
  const isToggledOn = useSyncExternalStore(subscribe, getSnapshot);

  return isTeamMember && isToggledOn;
}

export function useFeatureToggleControls() {
  const canToggle = useIsAmplifilesTeamMember();
  const enabled = useSyncExternalStore(subscribe, getSnapshot);

  return { canToggle, enabled, setEnabled: setFeatureToggle };
}
